import React from "react"
import { SpeedInsights } from "@vercel/speed-insights/next"
import { Analytics } from '@vercel/analytics/react'
import dynamic from 'next/dynamic';

import { MasterThemeProvider }  from "@backpack/context/MasterContext.js"
import Navigation from "@backpack/shared/nav/nav"
const Footer = dynamic(() => import('../footer.js'));

const Layout = ({ children }) => (
    <MasterThemeProvider>
        <Navigation
          author="Timothy Brantley II"
          menu={[
          { name: 'blog', link: '/logs' },
          { name: 'stories', link: '/stories' },
          { name: 'stream', link: '/stream' },
          { name: 'contact', link: '/schedule' },
          ]}
        />
        {children}
        <Footer />
        <Analytics  />
        <SpeedInsights />
    </MasterThemeProvider>
)

export default Layout
